import * as React from 'react'

const MOBILE_BREAKPOINT = 768

export function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
    const [isMobile, setIsMobile] = React.useState(
        () => typeof window !== 'undefined' && !window.matchMedia(`(min-width: ${breakpoint}px)`).matches
    )

    React.useEffect(() => {
        const mql = window.matchMedia(`(min-width: ${breakpoint}px)`)
        const onChange = () => {
            setIsMobile(!mql.matches)
        }
        mql.addEventListener('change', onChange)
        setIsMobile(!mql.matches)
        return () => mql.removeEventListener('change', onChange)
    }, [breakpoint])

    return isMobile
}
